export default {
  // 新订单详情
  all: 'All',
  toPay: 'To Pay',
  toDispatch: 'To Dispatch',
  inTransit: 'In Transit',
  completed: 'Completed',
  canceled: 'Canceled',
  rejected: 'Rejected',
  inTransitStatus: 'In Transit Status',
  toPickupByLogistics: 'To Pickup By Logistics',
  pickedUpByLogistics: 'Picked Up By Logistics',
  orderTime: 'Order Time',
  paymentTime: 'Payment Time',
  dispatchTime: 'Dispatch Time',
  completeTime: 'Complete Time',
  noLimit: 'No Limit',
  today: 'Today',
  yesterday: 'Yesterday',
  recent7Days: 'Recent 7 Days',
  recent30Days: 'Recent 30 Days',
  orderNumber: 'Order Number',
  billNumber: 'Bill Number',
  buyerID: 'Buyer ID',
  skuID: 'SKU ID',
  listingID: 'Listing ID',
  vendorProductID: 'Vendor Product ID',
  fulfillType: 'Fulfill Type',
  productName: 'Product Name',
  paymentType: 'Payment Type',
  fullyPrepaid: 'Fully Prepaid (online pay)',
  partialPrepaid: 'Partial Prepaid (pre-pay)',
  payOnDelivery: 'Pay on Delivery (cod)',
  paymentStatus: 'Payment Status',
  unpaid: 'Unpaid',
  paid: 'Paid',
  resetFilter: 'Reset Filter',
  export: 'Export',
  fold: 'Fold',
  more: 'More',
  batchOperation: 'Batch Operation',
  dispatch: 'Dispatch',
  printWaybill: 'Print Waybill',
  orderAmount: 'Order amount',
  skus: 'SKUs',
  qty: 'Qty',
  operation: 'Operation',
  product: 'Product',
  variant: 'Variant',
  unitPrice: 'Unit Price',
  detail: 'Detail',
  printList: 'Print List',
  trackOrder: 'Track Order',
  deleted: 'Deleted',
  logisticsInformation: 'Logistics Information',
  trackNo: 'Track No.',
  trackNumber: 'Track Number',
  close: 'Close',
  deliveryAddress: 'Delivery Address',
  parcel: 'Parcel',
  orderInformation: 'Order Information',
  orderStatus: 'Order Status',
  updateTime: 'Update Time',
  kindsOfSKU: 'Kinds of SKU',
  totalQuantity: 'Total Quantity',
  buyerName: 'Buyer Name',
  paymentInformation: 'Payment Information',
  productAmount: 'Product amount',
  shippingFee: 'Shipping fee',
  sellerVoucherRedeemed: 'Seller voucher redeemed',
  platformVoucherRedeemed: 'Platform voucher redeemed',
  coinRedeemed: 'Coin redeemed',
  paidAmount: 'Paid amount',
  dueAmount: 'Due amount',
  productInformation: 'Product Information',
  printPackingList: 'Print Packing List',
  totalPrice: 'Total Price',
  discount: 'Discount',
  gift: 'Gift',
  customCode: 'Custom Code',
  customCodeName: 'Custom Code Name',
  customCodeAttribute: 'Custom Code Attribute',
  customDeclaredValue: 'Custom Declared Value(CNY)',
  customCodeNameCN: 'Product Name(CN)',
  operationLog: 'Operation Log',
  operationType: 'Operation Type',
  from: 'From',
  operatorID: 'Operatior ID',
  dispatchingPanel: 'Dispatching Panel',
  deliverTo: 'Deliver to',
  dispatchFrom: 'Dispatch from',
  logisticsMethod: 'Logistics method',
  deliverByPlatformLogistics: 'Deliver by platform logistics (KiliExpress)',
  fulfillByMyself: 'Fulfill by myself',
  firstMileMethod: 'First-mile method',
  dropOffStation: 'Drop-off station',
  usePlatformPackingService: 'Use platform packing service?',
  yes: 'Yes',
  no: 'No',
  confirmToDispatch: 'Confirm to Dispatch',
  orderDetail: 'Order Detail',
  buyerPayableAmount: 'Buyer payable amount',
  discountTip: 'The direct discount amount applied from promotions (get instant deduction after reaching target amount), excluding voucher or coin deductions.',
  senderName: 'Sender’s name',
  senderPhone: 'Sender’s phone number',
  region: 'Region',
  address: 'Address',
  editDispatchAddress: 'Edit dispatching address',
  back: 'Back',
  submit: 'Submit',
  cancelOrder: 'Cancel Order',
  orderConfirmed: 'Order Confirmed',
  copyTip: 'Successfully Copied',
  show: 'Show',
  hide: 'Hide',
  productAmountTip: 'The total amount of the products after deducting the direct discount (excluding voucher or coin deductions).',
  shippingFeeTip: 'The total shipping fee after deducting the direct discount (excluding shipping voucher deductions).',
  selectReason: 'Select Reason',
  edit: 'Edit',
  deliverToDropOffStation: 'Deliver to Drop-off station',
  waybillNumber: 'Waybill Number',
  status: 'Status',
  sender: 'Sender',
  reason: 'Reason',
  viewReason: 'View Reason',
  orderCancellationDetials: 'Order Cancellation Detials',
  forWhatReason: 'For what reason?',
  whoCancelledThisOrder: 'Who cancelled this order?',
  iAmAware: 'I am aware',
  reasonRole1: 'Buyer',
  reasonRole2: 'Seller',
  reasonRole3: 'Marketplace Customer Care',
  reasonRole9: 'Marketplace System',
  buyerUnpaid: 'Buyer unpaid.'
}
